module.exports = __webpack_public_path__ + "static/media/e-commerce.1006c5ad.jpg";